/*
 * Saga to join updated channel if it wasn't previously
 */

import { take, put, select, takeEvery, call, cancel } from 'redux-saga/effects';
import get from 'lodash/get';
import {
  chatModuleInstanceSelector,
  availableChannelsSelector,
} from '../selectors';
import { subChannelsSelector } from '../../board/selectors/channels';
import chatConsts from '../constants';
import { consts as channels } from '../../board/channels';
import { consts as reqChannel } from '../../board/reqChannel';
import { consts as settings } from '../../board/settings';
import { isHealthBoardPage } from '../helpers/isHealthboardSaga';
import { currentLocationSelector } from '../../common/selectors';
import { APPOINTMENT_FORM } from '../../../constants/routes';

function* newChannelActivityWorker(action) {
  const isHealthBoard = yield call(isHealthBoardPage);
  const location = yield select(currentLocationSelector);
  const isSelfSchedulingFlow = location.includes(APPOINTMENT_FORM);

  if (isHealthBoard || isSelfSchedulingFlow) yield cancel();

  const {
    channelId: id,
    message: { masterUserId, insertedAt, chatRoomUid },
  } = action.payload;
  const channelId = parseInt(id, 10);

  const state = yield select();
  const chatModuleInstance = chatModuleInstanceSelector(state);
  const availableChannels = availableChannelsSelector(state);

  const containingGroup = Object.keys(availableChannels).find(key =>
    get(availableChannels[key], [masterUserId, channelId]),
  );

  /**
   *    CONTAIN GROUP
   * */
  if (containingGroup) {
    // initialize new CircleOfCareChannel instance with existed unreadCounter data
    const { totalUnreadCount } = get(availableChannels, [
      containingGroup,
      masterUserId,
      channelId,
    ]);

    chatModuleInstance.createChannel(channelId, {
      unreadCount: totalUnreadCount + 1,
      lastMessageAt: insertedAt,
    });

    yield cancel();
  }

  /**
   *  NOT IN GROUP
   * */
  // request circleOfCare data before initializing new CircleOfCareChannel instance
  yield put({
    type: reqChannel.SEND,
    payload: { id: chatRoomUid },
  });

  const { payload: circleOfCare } = yield take(a => {
    const context = a.payload ? a.payload.contextUser : '';
    if (context) {
      return (
        a.type === reqChannel.SUCCEED &&
        a.payload.contextUser.id === masterUserId
      );
    }
    return a.type === reqChannel.SUCCEED;
  });

  if (circleOfCare) {
    const updatedChannel = get(circleOfCare, 'subchannels', []).find(
      channel => channel.channelId === channelId,
    );

    if (updatedChannel) {
      // initialize new CircleOfCareChannel instance with existed unreadCounter data
      const { lastMessageAt, totalUnreadCount } = updatedChannel;
      chatModuleInstance.createChannel(channelId, {
        unreadCount: totalUnreadCount,
        lastMessageAt,
      });

      yield put({
        type: channels.ADD_ITEMS,
        payload: circleOfCare,
      });

      const updatedChannels = yield select(subChannelsSelector); // to test

      yield put({
        type: chatConsts.UPDATE_AVAILABLE_CHANNELS,
        payload: updatedChannels,
      });

      yield put({
        type: settings.ADD_EXCLUDED_ID,
        payload: circleOfCare.id,
      });
    } else {
      const { totalUnreadCount } = circleOfCare;

      chatModuleInstance.createChannel(channelId, {
        unreadCount: totalUnreadCount,
        lastMessageAt: insertedAt,
      });

      yield put({
        type: channels.ADD_ITEMS,
        payload: circleOfCare,
      });
    }
  }
}

export default function* newChannelActivitySaga() {
  yield takeEvery([chatConsts.NEW_CHANNEL_ACTIVITY], newChannelActivityWorker);
}



// WEBPACK FOOTER //
// ./src/redux/chatConnection/sagas/newChannelActivity.js